export default function getNavigatorCredentials(): CredentialsContainer | undefined {
  // eslint-disable-next-line no-restricted-properties -- This is the one place where we access it. Note the return type above ensuring that we deal with the undefined case
  return navigator.credentials;
}
